
import { defineComponent, onMounted } from 'vue';
import useChallenge from '@/modules/challenge/model/edit';
import {
    AppFormRow,
    AppInput,
    AppButton,
    AppCard,
    AppSelect,
    AppFileUpload,
    AppImageHolder,
    AppDateTimePicker
} from '@/components';
import { ROUTE_NAME_CHALLENGE } from '@/modules/challenge/router';
import { useAppStore } from '@/modules/apps/store';
import { storeToRefs } from 'pinia';

export default defineComponent({
    name: ROUTE_NAME_CHALLENGE.EDIT,
    components: {
        AppFormRow,
        AppInput,
        AppButton,
        AppSelect,
        AppCard,
        AppFileUpload,
        AppImageHolder,
        AppDateTimePicker
    },
    setup() {
        const { appSelectOptions } = storeToRefs(useAppStore());
        const { model, v$, fetch, update } = useChallenge();

        onMounted(() => {
            fetch();
        });

        return { v$, model, appSelectOptions, update };
    }
});
